import { Link, useLocation } from "react-router-dom";
import { hasPermission } from "../../utils/permission";

import {
  FaTachometerAlt,
  FaUsers,
  FaGift,
  FaCog,
  FaWallet,
  FaChartBar,
  FaMoneyBillWave,
  FaChartLine,
  FaExclamationTriangle,
  FaShopify,
  FaUndoAlt,
  FaShieldAlt,
  FaHandshake
} from "react-icons/fa";

function AdminSidebar({ setSidebarOpen }) {

  const location = useLocation();

  const menus = [
  {
    icon: <FaTachometerAlt />,
    text: "Dashboard",
    path: "/admin/dashboard",
    permission: "dashboard.view",
  },

  {
    icon: <FaShieldAlt />,
    text: "Permissions",
    path: "/admin/permissions",
    permission: "permission.view",
  },

  {
    icon: <FaShieldAlt />,
    text: "Roles",
    path: "/admin/roles",
    permission: "role.view",
  },

  {
    icon: <FaHandshake />,
    text: "Partner",
    path: "/admin/partners",
    permission: "partner.view",
  },

  {
    icon: <FaUsers />,
    text: "Users",
    path: "/admin/users",
    permission: "user.view",
  },

  {
    icon: <FaShopify />,
    text: "Businesses",
    path: "/admin/businesses",
    permission: "business.view",
  },

  {
    icon: <FaWallet />,
    text: "Wallets",
    path: "/admin/wallets",
    permission: "wallet.view",
  },

  {
    icon: <FaGift />,
    text: "Categories",
    path: "/admin/categories",
    permission: "category.view",
  },

  {
    icon: <FaGift />,
    text: "Products",
    path: "/admin/products",
    permission: "product.view",
  },

  {
    icon: <FaUsers />,
    text: "Customers",
    path: "/admin/customers",
    permission: "customer.view",
  },

  {
    icon: <FaUsers />,
    text: "Suppliers",
    path: "/admin/suppliers",
    permission: "supplier.view",
  },

  {
    icon: <FaWallet />,
    text: "Purchases",
    path: "/admin/purchases",
    permission: "purchase.view",
  },

  // {
  //   icon: <FaUndoAlt />,
  //   text: "Purchase Returns",
  //   path: "/admin/purchase-returns",
  //   permission: "purchase_return.view",
  // },

  // {
  //   icon: <FaChartBar />,
  //   text: "Create Invoice",
  //   path: "/admin/invoices/create",
  //   permission: "invoice.add",
  // },

  {
    icon: <FaChartBar />,
    text: "Invoices",
    path: "/admin/invoices",
    permission: "invoice.view",
  },

  // {
  //   icon: <FaUndoAlt />,
  //   text: "Sales Returns",
  //   path: "/admin/sales-returns",
  //   permission: "sales_return.view",
  // },

  {
    icon: <FaChartBar />,
    text: "Sales Report",
    path: "/admin/sales-report",
    permission: "sales_report.view",
  },

  {
    icon: <FaChartBar />,
    text: "Stock Report",
    path: "/admin/stock-report",
    permission: "stock_report.view",
  },

  {
    icon: <FaMoneyBillWave />,
    text: "Expenses",
    path: "/admin/expenses",
    permission: "expense.view",
  },

  {
    icon: <FaChartLine />,
    text: "Profit & Loss",
    path: "/admin/profit-loss",
    permission: "profit_loss.view",
  },

  {
    icon: <FaExclamationTriangle />,
    text: "Low Stock",
    path: "/admin/low-stock",
    permission: "low_stock.view",
  },

  {
    icon: <FaCog />,
    text: "Settings",
    path: "/admin/settings",
    permission: "setting.view",
  },
];

  return (
    <div
      className="
      fixed
      left-0
      top-0
      w-72
      h-screen
      bg-[#0b0b0b]
      border-r
      border-yellow-500/20
      p-6
      overflow-y-auto
      "
    >
      <h1
        className="
        text-3xl
        font-bold
        text-yellow-400
        mb-10
        "
      >
        Billing Software
      </h1>

      <div className="space-y-3">
        {
          menus
            .filter(menu => hasPermission(menu.permission))
            .map(menu => (
              <Link
                key={menu.path}
                to={menu.path}
                onClick={() =>
                  setSidebarOpen &&
                  setSidebarOpen(false)
                }
              >
                <div
                  className={`
              flex
              items-center
              gap-4
              p-4
              rounded-xl
              transition-all
              cursor-pointer

              ${location.pathname === menu.path
                      ? "bg-yellow-500 text-black font-semibold"
                      : "text-white hover:bg-yellow-500/10"
                    }
            `}
                >
                  <span className="text-lg">
                    {menu.icon}
                  </span>

                  <span>
                    {menu.text}
                  </span>
                </div>
              </Link>
            ))}
      </div>
    </div>
  );
}

export default AdminSidebar;